import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit-html';

class ZuiWellAction extends ZuiBaseElement {
  _renderStyle() {
    return html`
      <style>
        :host{--zui-button-color: var(--zui-well-action-color);--zui-button-hover-color: var(--zui-well-action-hover-color);color:var(--zui-button-color);font-weight:700;text-decoration:none;text-transform:uppercase;background:transparent;border:0;padding:0;margin:30px 0 0 0;cursor:pointer}:host ::slotted(*){color:var(--zui-button-color);font-weight:700;text-decoration:none;text-transform:uppercase;background:transparent;border:0;padding:0;margin:30px 0 0 0}:host ::slotted(:hover){color:var(--zui-button-hover-color);cursor:pointer}
      </style>
    `;
  }

  render() {
    return html`
      ${this._renderStyle()} <slot></slot>
    `;
  }

}

customElements.define('zui-well-action', ZuiWellAction);